import createPersistedState from 'vuex-persistedstate'
import Prefetch from './prefetch-data'
import * as Cookies from 'js-cookie'

const hostName = window.location.hostname
// prepend cookie domain with . for subdomains on production environment
const cookieDomain = hostName === 'localhost' ? 'localhost' : `.${hostName.slice(hostName.indexOf('.') + 1)}`
const plugins = [
  Prefetch,
  createPersistedState({
    key: 'config',
    paths: ['AUTH', 'CART'],
    reducer: (state) => ({
      AUTH: { token: state.AUTH.token },
      identifier: state.identifier,
      printer: state.printer,
      isMini: state.isMini
    }),
    storage: {
      getItem: key => Cookies.get(key, { domain: cookieDomain }),
      setItem: (key, value) => Cookies.set(key, value, {
        domain: cookieDomain,
        expires: new Date('December 31, 2097')
      }),
      removeItem: key => Cookies.remove(key, { domain: cookieDomain })
    }
  })
]

export default plugins
